import { Component, Schema, type, defaultValue } from "minecs";
@Component()
export class AirportStaff extends Schema {
    @type("number")
    @defaultValue(0)
    stage: number;
    @type("number")
    @defaultValue(-1)
    homeStage: number;
    @type("string")
    @defaultValue("clerk")
    role: string;
    @type("number")
    @defaultValue(0)
    task: number;
    /** Stable terminal-record identity from AirportState.nextStaffId; never derived from the ECS body id. */
    @type("string")
    @defaultValue("")
    recordId: string;
    /** MGT-003 skill pips (1–3). */
    @type("number")
    @defaultValue(1)
    skill: number;
    /** MGT-004 energy (0–100); drains only from Act II. */
    @type("number")
    @defaultValue(100)
    energy: number;
    /** Frames of off-floor training left (MGT-003). */
    @type("number")
    @defaultValue(0)
    training: number;
    /** On a break in the staff room (MGT-004). */
    @type("boolean")
    @defaultValue(false)
    onBreak: boolean;
}
